module.exports = __webpack_public_path__ + "img/P2051571.6211c1c2.jpg";